import {store} from "../../../store/store";
import {AlertType, snackbarActions} from "../models/SnackbarSlice";
import Api from "../../../Api";
import {logoutUser, setIsAuthenticated, setAccessToken} from "../../auth/models/AuthSlice";
import CryptoJS from "crypto-js";

class CommonUtils {
    static toCapitalizeCase = (text) => {
        return text.toLowerCase().charAt(0).toUpperCase() + (text.slice(1).toLowerCase())
    }

    static logoutUser() {
        store.dispatch(logoutUser(null))
        window.location.href = "/"

    }

    static getEncryptionKey() {
        const key = process.env.REACT_APP_ENCRYPTION_KEY;
        if (!key) {
            throw new Error("Encryption key is missing from environment variables.");
        }
        return CryptoJS.enc.Hex.parse(key);
    }

    // Static method to encrypt a password using the encryption key
    static encryptPassword(password) {
        const key = this.getEncryptionKey();
        const iv = CryptoJS.lib.WordArray.random(16); // Generate a 16-byte IV

        // Encrypt using AES-CBC with PKCS7 padding
        const encrypted = CryptoJS.AES.encrypt(password, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        // Concatenate IV and encrypted data as Base64 strings, separated by a colon
        return iv.toString(CryptoJS.enc.Base64) + ":" + encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }

    static getPaperHeight(headerHeight, rowPadding) {
        const contentDivHeight = store.getState().base.contentDivHeight;
        return contentDivHeight - 2.5 * rowPadding - headerHeight - 5;
    }

    static async checkUserAuthentication() {
        const response =  await Api.getAccessToken();
        // console.log("access token", response);
        if (response) {
            store.dispatch(setAccessToken(response));
            store.dispatch(setIsAuthenticated(true));
            // store.dispatch(loginUser)
            return true
        }
        return false

    }

    static getUserInfo() {
        let userInfo = store.getState().auth.userInfo;
        console.log("UserInfo: ", userInfo);
        return typeof userInfo === "string" ? JSON.parse(userInfo) : userInfo;
    }

    static showSnackbar(msg, alertType ) {
        if (alertType == null) alertType = AlertType.info
        store.dispatch(snackbarActions.showSnackbar({msg: msg, alertType: alertType}));
    }


}

export default CommonUtils;
